import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-video-cut-icon]',
  template: `
    <svg:path
      d="M13.333 2C13.6866 2 14.0258 2.14048 14.2758 2.39052C14.5259 2.64057 14.6663 2.97971 14.6663 3.33333V12.6667C14.6663 13.0203 14.5259 13.3594 14.2758 13.6095C14.0258 13.8595 13.6866 14 13.333 14H2.66634C2.31272 14 1.97358 13.8595 1.72353 13.6095C1.47348 13.3594 1.33301 13.0203 1.33301 12.6667V3.33333C1.33301 2.97971 1.47348 2.64057 1.72353 2.39052C1.97358 2.14048 2.31272 2 2.66634 2H13.333ZM10.6663 3.33333H5.33301V12.6667H10.6663V3.33333ZM13.333 11.3333H11.9997V12.6667H13.333V11.3333ZM3.99967 11.3333H2.66634V12.6667H3.99967V11.3333ZM13.333 8.66667H11.9997V10H13.333V8.66667ZM3.99967 8.66667H2.66634V10H3.99967V8.66667ZM13.333 6H11.9997V7.33333H13.333V6ZM3.99967 6H2.66634V7.33333H3.99967V6ZM13.333 3.33333H11.9997V4.66667H13.333V3.33333ZM3.99967 3.33333H2.66634V4.66667H3.99967V3.33333Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
    '[class]': 'extraClass()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoCutIcon {
  readonly viewBox = input<string>('0 0 16 16');
  readonly extraClass = input<string>('');
}
